import React from "react";
import UserData from "../../userdata.json";
import { ReactComponent as Menu } from "../../images/hanburger.svg";

function Nav({ handleIsVsible }) {

  
  return (
    <div className="flex w-100 justify-between bb ph6-l ph4 pv3 glassmorphic-1 items-center ">
      <div className="logo f2">Utkarsh Verma</div>
      <div className="dn-l " onClick={handleIsVsible}>
        <Menu className="w2 h2 svg-path-fill-primary"/>
      </div>
      <div className="flex-l dn w-40 justify-between">
        {UserData?.navtabs?.map((tab, index) => (
          <div
            key={index + tab}
            className=" fw9 transition-color pointer  pa3 "
          >
            <a
            href={`#${tab}`}
              className="primary no-underline hover-tertiary transition-all-0-5"
            >
              {tab}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Nav;
